import { render, staticRenderFns } from "./DialogoBuscarPecas.vue?vue&type=template&id=4caba8d6&scoped=true&"
import script from "./DialogoBuscarPecas.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarPecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caba8d6",
  null
  
)

export default component.exports